import { render, staticRenderFns } from "./commentsModal.vue?vue&type=template&id=f7fd1258&"
import script from "./commentsModal.vue?vue&type=script&lang=js&"
export * from "./commentsModal.vue?vue&type=script&lang=js&"
import style0 from "./commentsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports